module.exports = __webpack_public_path__ + "img/THEOS_background.a6f2be7b.png";